export default __webpack_public_path__ + "8a9a11630f5adb03a97520e23754a430.png";